import { useState } from "react"
import { Card, Button, Badge, Table, Tabs, Alert, Space, Typography } from "antd"
import {
  DollarOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons"
const { Title, Text } = Typography
const { TabPane } = Tabs


const Execution = () => {
  const [selectedTab, setSelectedTab] = useState("executions")

  // Table data
  const executionsData = [
    {
      key: "1",
      action: "Supply Chain Diversification",
      signal: "Geopolitical Risk Alert",
      impact: "+$340K",
      confidence: "94%",
      window: "14 days",
    },
    {
      key: "2",
      action: "Pricing Strategy Pivot",
      signal: "Market Trend Analysis",
      impact: "+$180K",
      confidence: "87%",
      window: "7 days",
    },
    {
      key: "3",
      action: "Compliance Automation",
      signal: "AI Regulation Trend",
      impact: "+$350K",
      confidence: "91%",
      window: "21 days",
    },
  ]

  const autoExecutionsData = [
    {
      key: "1",
      action: "Currency Hedge Activation",
      signal: "FX Volatility Spike",
      impact: "+$125K",
      time: "2.3 seconds",
    },
    {
      key: "2",
      action: "Inventory Rebalancing",
      signal: "Demand Pattern Shift",
      impact: "+$89K",
      time: "45 seconds",
    },
  ]

  const missedOpportunitiesData = [
    {
      key: "1",
      opportunity: "GTM Signal in LatAm",
      date: "15 days ago",
      loss: "-$480K",
      status: "Ignored",
    },
  ]

  const executionsColumns = [
    {
      title: "Action Taken",
      dataIndex: "action",
      key: "action",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Signal Source",
      dataIndex: "signal",
      key: "signal",
    },
    {
      title: "$ Impact",
      dataIndex: "impact",
      key: "impact",
      render: (text) => <Text style={{ color: "#52c41a", fontWeight: "bold" }}>{text}</Text>,
    },
    {
      title: "Confidence",
      dataIndex: "confidence",
      key: "confidence",
      render: (text) => <Badge color="blue" text={text} />,
    },
    {
      title: "Window",
      dataIndex: "window",
      key: "window",
    },
  ]

  const autoExecutionsColumns = [
    {
      title: "Auto-Action",
      dataIndex: "action",
      key: "action",
      render: (text) => (
        <Space>
          <ThunderboltOutlined style={{ color: "#1890ff" }} />
          <Text strong>{text}</Text>
        </Space>
      ),
    },
    {
      title: "Trigger Signal",
      dataIndex: "signal",
      key: "signal",
    },
    {
      title: "$ Impact",
      dataIndex: "impact",
      key: "impact",
      render: (text) => <Text style={{ color: "#52c41a", fontWeight: "bold" }}>{text}</Text>,
    },
    {
      title: "Execution Time",
      dataIndex: "time",
      key: "time",
    },
  ]

  const missedOpportunitiesColumns = [
    {
      title: "Missed Opportunity",
      dataIndex: "opportunity",
      key: "opportunity",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Signal Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Est. Loss",
      dataIndex: "loss",
      key: "loss",
      render: (text) => <Text style={{ color: "#ff4d4f", fontWeight: "bold" }}>{text}</Text>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <Badge status="error" text={text} />,
    },
    {
      title: "Action",
      key: "action",
      render: () => <Button size="small">Re-activate</Button>,
    },
  ]

  return (
    <Card style={{ marginBottom: "24px" }}>
          <Title level={4}>
            <DollarOutlined style={{ marginRight: "8px" }} />
            Execution-Adjusted Financial Impact
          </Title>
          <Text type="secondary">
            What your team did or what Radar auto-did — and how much money it made or saved you.
          </Text>

          <Tabs activeKey={selectedTab} onChange={setSelectedTab} style={{ marginTop: "16px" }}>
            <TabPane tab="Executions" key="executions">
              <Table dataSource={executionsData} columns={executionsColumns} pagination={false} size="middle" />
            </TabPane>
            <TabPane tab="Auto-Executions" key="auto-executions">
              <Table dataSource={autoExecutionsData} columns={autoExecutionsColumns} pagination={false} size="middle" />
            </TabPane>
            <TabPane tab="Missed Executions" key="missed">
              <div style={{ marginBottom: "16px" }}>
                <Alert
                  message="High-Value Strategy Delayed"
                  description="LatAM expansion stuck in legal review: 18 days → $92K projected loss"
                  type="error"
                  showIcon
                  action={<Button size="small">Escalate</Button>}
                />
              </div>
              <Table
                dataSource={missedOpportunitiesData}
                columns={missedOpportunitiesColumns}
                pagination={false}
                size="middle"
              />
            </TabPane>
          </Tabs>
        </Card>
  )
}

export default Execution